import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import ZendeskChat, { ZendeskAPI } from './ZendeskConfig'
import { STUDY_CONFIG_MAP } from 'utils/constants'

const ZENDESK_WIDGET_KEY = 'f935c57c-c325-4ebf-bc7b-c1c12f724b24'

const isUserLoggedIn = user => user && Object.keys(user).length > 0

const isStudyDetailPath = pathname => /^\/studies\/\d+(\/.*)?$/.test(pathname)

const isZendeskReady = () => typeof window !== 'undefined' && window.zE

const Zendesk = ({ user, location, config }) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(isZendeskReady)

  const enabled =
    isUserLoggedIn(user) &&
    isStudyDetailPath(location.pathname) &&
    !!config[STUDY_CONFIG_MAP.zendesk]

  const handleLoaded = useCallback(() => {
    setIsScriptLoaded(true)
  }, [])

  useEffect(() => {
    if (!isScriptLoaded) return

    if (enabled) {
      ZendeskAPI('messenger', 'show')
    } else {
      ZendeskAPI('messenger', 'hide')
    }
  }, [location.pathname, user, config, enabled, isScriptLoaded])

  if (!enabled) return null

  return <ZendeskChat defer zendeskKey={ZENDESK_WIDGET_KEY} onLoaded={handleLoaded} />
}

const mapStateToProps = state => ({
  user: state.user || {},
  location: state.location,
  config: state.study?.currentStudy?.config || {},
})

export default connect(mapStateToProps)(Zendesk)
